var _g, _path, _g2, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTakeSeat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 36,
    viewBox: "0 0 54 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_369_8250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2.295A2.297 2.297 0 012.298 0h21.404A2.297 2.297 0 0126 2.295v31.41A2.297 2.297 0 0123.702 36H2.298A2.297 2.297 0 010 33.705V2.295z",
    fill: "#D0392B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.702 1.147H2.298c-.634 0-1.149.514-1.149 1.148v31.41c0 .634.515 1.148 1.15 1.148h21.403c.634 0 1.149-.514 1.149-1.148V2.295c0-.634-.515-1.148-1.15-1.148zM2.298 0A2.297 2.297 0 000 2.295v31.41A2.297 2.297 0 002.298 36h21.404A2.297 2.297 0 0026 33.705V2.295A2.297 2.297 0 0023.702 0H2.298z",
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.159 16.766l1.102 3.033-2.715-1.859-2.612 1.904.933-3.051-2.717-1.858 3.297-.028.932-3.05 1.099 3.032 3.294-.028-2.613 1.905zm2.133-4.95a478.886 478.886 0 00-4.018-3.725s-1.486 1.453-3.809 3.792C8.237 13.118 5.485 16.18 5.57 19.2c.055 2.014 1.78 3.633 3.853 3.614 1.36-.011 2.12-.409 3.157-1.784 0 0 .17-.144.292-.145.193-.002.372.13.358.294-.115 1.086-.672 3.769-3.127 4.693l7.323-.063c-2.505-.88-3.208-3.553-3.38-4.637-.028-.163.146-.297.338-.299.12-.002.3.14.3.14 1.088 1.087 1.892 1.74 3.253 1.728 2.072-.016 3.708-1.664 3.65-3.677-.082-3.021-3-6.034-4.294-7.246z",
    fill: "#fff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_369_8250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 2.295A2.297 2.297 0 0130.298 0h21.404A2.297 2.297 0 0154 2.295v31.41A2.297 2.297 0 0151.702 36H30.298A2.297 2.297 0 0128 33.705V2.295z",
    fill: "#D0392B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.702 1.147H30.298c-.634 0-1.149.514-1.149 1.148v31.41c0 .634.515 1.148 1.15 1.148h21.403c.634 0 1.149-.514 1.149-1.148V2.295c0-.634-.515-1.148-1.15-1.148zM30.298 0A2.297 2.297 0 0028 2.295v31.41A2.297 2.297 0 0030.298 36h21.404A2.297 2.297 0 0054 33.705V2.295A2.297 2.297 0 0051.702 0H30.298z",
    fill: "#fff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.159 16.766l1.102 3.033-2.715-1.859-2.612 1.904.933-3.051-2.717-1.858 3.297-.028.931-3.05 1.1 3.032 3.294-.028-2.613 1.905zm2.133-4.95a478.886 478.886 0 00-4.018-3.725s-1.486 1.453-3.809 3.792c-1.228 1.235-3.98 4.296-3.896 7.316.055 2.014 1.78 3.633 3.853 3.614 1.36-.011 2.12-.409 3.157-1.784 0 0 .17-.144.292-.145.193-.002.372.13.358.294-.115 1.086-.672 3.769-3.127 4.693l7.323-.063c-2.505-.88-3.208-3.553-3.38-4.637-.028-.163.146-.297.338-.299.12-.002.3.14.3.14 1.088 1.087 1.892 1.74 3.253 1.728 2.072-.016 3.708-1.664 3.65-3.677-.082-3.021-3-6.034-4.294-7.246z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_369_8250"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h26v36H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_369_8250"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(28)",
    d: "M0 0h26v36H0z"
  })))));
}
SvgTakeSeat.displayName = 'TakeSeat';
export default SvgTakeSeat;